var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormItem',_vm._b({},'FormItem',_vm.itemProps,false),[_c('i-switch',{attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }